import { render, staticRenderFns } from "./ReviewPublication.vue?vue&type=template&id=563564e9&scoped=true"
import script from "./ReviewPublication.vue?vue&type=script&lang=js"
export * from "./ReviewPublication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563564e9",
  null
  
)

export default component.exports